import React         from 'react';
import { useRouter } from '../../../common/hooks/useRouter';

const PrevPageArrow = function() {
  const { history: { goBack } } = useRouter();

  return (
    <svg
      className={'prev_page_arrow'}
      width="9"
      height="16"
      viewBox="0 0 9 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={goBack}
    >
      <path
        d="M8.28033 15.2803C8.5466 15.0141 8.5708 14.5974 8.35295 14.3038L8.28033 14.2197L1.811 7.75L8.28033 1.28033C8.5466 1.01406 8.5708 0.597401 8.35295 0.303789L8.28033 0.219671C8.01406 -0.0465956 7.5974 -0.0708018 7.30379 0.147053L7.21967 0.219671L0.219671 7.21967C-0.046596 7.48594 -0.0708022 7.9026 0.147052 8.19621L0.219671 8.28033L7.21967 15.2803C7.51256 15.5732 7.98744 15.5732 8.28033 15.2803Z"
        fill="#488EC8"
      />
      <path
        d="M8.28033 15.2803C8.5466 15.0141 8.5708 14.5974 8.35295 14.3038L8.28033 14.2197L1.811 7.75L8.28033 1.28033C8.5466 1.01406 8.5708 0.597401 8.35295 0.303789L8.28033 0.219671C8.01406 -0.0465956 7.5974 -0.0708018 7.30379 0.147053L7.21967 0.219671L0.219671 7.21967C-0.046596 7.48594 -0.0708022 7.9026 0.147052 8.19621L0.219671 8.28033L7.21967 15.2803C7.51256 15.5732 7.98744 15.5732 8.28033 15.2803Z"
        fill="#BCBCBC"
      />
    </svg>
  );
};

export default PrevPageArrow;